export const IMAGE_CONTAINER_ID = 'IMAGE_CONTAINER';
export const IMAGE_CATEGORIES = {
    TRAILER_NUMBER: 'TRAILER_NUMBER',
    TRUCK_NUMBER: 'TRUCK_NUMBER',
    CAMERA_SNAPSHOT: 'CAMERA_SNAPSHOT',
    PLAYBACK_SNAPSHOT: 'PLAYBACK_SNAPSHOT',
    FACE_MATCH_SNAPSHOT: 'FACE_MATCH_SNAPSHOT',
};
export const STREAM_FOOTER_ICON_STYLE = { cursor: 'pointer', width: '24px', height: '24px' };
export const STREAM_FOOTER_MENU_ICON_STYLE = { width: 24, height: 24, color: 'grey' };

// A camera frame is captured within one render; past this an OCR capture counts as lost (e.g. the video element was
// replaced mid-capture and TakeSnapshot threw before its callback), so the OCR action is enabled again.
export const OCR_CAPTURE_TIMEOUT_MS = 5000;

export const FACE_CAMERA_TYPES = {
    TRUCK: { face: 'TRUCK_FACE', id: 'TRUCK_ID' },
    CAR: { face: 'CAR_FACE', id: 'CAR_ID' },
};
